import { useQuery } from "@tanstack/react-query";
import { CompanyNameDto } from "@green0meter/api-client";

import { DOMAIN_PROCUREMENT } from "../domain";

import { procurementApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";

export const ACTION_GET_COMPANY_DETAIL = "GET_COMPANY_DETAIL";

/*****************
 * Public route *
 *****************/

interface GetCompanyDetailRequest {
  companyId: string;
}

const getCompanyName = async (
  params: GetCompanyDetailRequest,
): Promise<CompanyNameDto> => {
  const { companyId } = params;

  const response =
    await procurementApi.procurementControllerGetBuyerCompanyName(companyId);

  return response.data;
};

export const useGetCompanyName = (
  params: GetCompanyDetailRequest,
): {
  company: CompanyNameDto | undefined;
  isPendingCompanyDetail: boolean;
  isSucessGetCompanyDetail: boolean;
} => {
  const { data, isPending, isSuccess } = useQuery({
    queryKey: [DOMAIN_PROCUREMENT, ACTION_GET_COMPANY_DETAIL],
    queryFn: () => getCompanyName(params),
    select: (response) => response,
    staleTime: TANSTACK_QUERY_STALE_TIME,
  });

  return {
    company: data,
    isPendingCompanyDetail: isPending,
    isSucessGetCompanyDetail: isSuccess,
  };
};
